import { put } from 'redux-saga/effects';

import * as endpoint from 'misc/endpoint';
import * as types from 'misc/types';

export function* getEnvelopeContentBody(action) {
    try {
        
        // Open movies in new tab
        if (action.contentInfo.presentationType === types.PRESENTATION_TYPES.MOVIE) {
            window.open(action.contentInfo.url, '_self');
        } else {
       
            const response = yield endpoint.get(
                    'envelopes/' +
                    action.contentInfo.envelopeId +
                    '/body/' +
                    action.contentInfo.id +
                    '/data'
            );
            
            if(action.inline){
                yield put({
                    type: types.SAGA_ENVELOPE_CONTENT_INLINE_GET.SUCCESS,
                    payload: {
                        id: action.contentInfo.id,
                        contentType: action.contentInfo.contentType,
                        data: response.data
                    }
                });
            }else{
                yield put({
                    type: types.SAGA_ENVELOPE_CONTENT_DOCUMENT_GET.SUCCESS,
                    payload: {
                        id: action.contentInfo.id,
                        contentType: action.contentInfo.contentType,
                        data: response.data
                    }
                });
            }
        }
    } catch (error) {
        if(action.inline){
            yield put({ type: types.SAGA_ENVELOPE_CONTENT_INLINE_GET.FAILURE, error });
        }else{
            yield put({ type: types.SAGA_ENVELOPE_CONTENT_DOCUMENT_GET.FAILURE, error });
        }
    }
}



// WEBPACK FOOTER //
// ./src/sagas/envelope_content_body.js